import { ReactNode } from 'react';

type Validator = (
  value: unknown,
  values: Record<string, unknown>
) => null | ReactNode;

export const every =
  (...validators: Validator[]) =>
  (value: unknown, values: Record<string, unknown>) => {
    for (const validator of validators) {
      const result = validator(value, values);

      if (result) {
        return result;
      }
    }

    return null;
  };
